import { Link } from 'react-router';

import { ROUTES } from '@/shared/config';
import { CareerTrack } from '@/widgets/career-track';

import styles from './CareerPage.module.scss';

export function CareerPage() {
  return (
    <div className={styles.page}>
      <div className={styles.titleRow}>
        <Link className={styles.back} to={ROUTES.home} aria-label="Назад">
          <img src="/images/matches/back.svg" alt="" aria-hidden className={styles.backIcon} />
        </Link>
        <h1 className={styles.title}>Карьера</h1>
      </div>

      <CareerTrack />
    </div>
  );
}
